export const API_EXTERNAL_ENDPOINT = 'how-platform-works-page'

export const API_INTERNAL_ENDPOINT = 'strapi/how-platform-works-page'
